import React, { useState } from "react";
import { CATEGORIES, DEFAULT_CONSENT } from "../lib/consent";

/**
 * GDPR-compliant consent banner.
 * - Equal prominence for "Accept all" and "Reject all"
 * - Granular per-category toggles
 * - No non-essential script loads before a choice is made
 */
const ConsentBanner = ({ onSave, onAcceptAll, onRejectAll, onOpenPrivacy }) => {
  const [showPrefs, setShowPrefs] = useState(false);
  const [draft, setDraft] = useState(DEFAULT_CONSENT);

  const toggle = (id) => {
    if (CATEGORIES[id].required) return;
    setDraft((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="consent" role="dialog" aria-modal="false" aria-labelledby="consent-title">
      <div className="consent__panel">
        <div>
          <h2 className="consent__title" id="consent-title">
            Your privacy matters
          </h2>
          <p className="consent__text">
            We use strictly necessary storage to run this site. With your permission we would also
            like to use analytics cookies (Google Analytics) and load Google Maps. You can change
            your mind at any time via “Cookie settings” in the footer.{" "}
            <button type="button" className="link-btn" onClick={onOpenPrivacy}>
              Read our privacy policy
            </button>
            .
          </p>
        </div>

        <div className="consent__actions">
          <button type="button" className="btn btn--ghost btn--sm" onClick={onRejectAll}>
            Reject all
          </button>
          <button
            type="button"
            className="btn btn--ghost btn--sm"
            onClick={() => setShowPrefs((v) => !v)}
            aria-expanded={showPrefs}
          >
            {showPrefs ? "Hide settings" : "Customise"}
          </button>
          <button type="button" className="btn btn--primary btn--sm" onClick={onAcceptAll}>
            Accept all
          </button>
        </div>

        {showPrefs && (
          <div className="consent__prefs">
            {Object.values(CATEGORIES).map((cat) => (
              <div className="consent__row" key={cat.id}>
                <div>
                  <strong>{cat.title}</strong>
                  <span>{cat.description}</span>
                </div>
                <button
                  type="button"
                  role="switch"
                  aria-checked={cat.required ? true : !!draft[cat.id]}
                  aria-label={`${cat.title} cookies`}
                  className="switch"
                  disabled={cat.required}
                  onClick={() => toggle(cat.id)}
                />
              </div>
            ))}
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 6 }}>
              <button
                type="button"
                className="btn btn--primary btn--sm"
                onClick={() => onSave({ ...draft, necessary: true })}
              >
                Save preferences
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsentBanner;
